/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import {alert} from 'util/alert'
import {confirm} from 'util/confirm'
import QRCode from 'components/UI/QrCode';
import locale from './locale'
import getPosterOrderPay from 'controllers/payment/getPosterOrderPay'
import './Modal.scss';


class ModalContent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      step: 1,
    }

    this.checkPayment = this.checkPayment.bind(this)
  }

  componentDidMount(){
    let checkPayment = setInterval(this.checkPayment, 5000)
    this.setState({ checkPayment: checkPayment})
  }

  componentWillUnmount(){
    clearInterval(this.state.checkPayment)
  }

  checkPayment(){
    const {order_number} = this.props

    getPosterOrderPay(order_number)
    .then((res) => {
      if(res.payment_result == 'success'){
        clearInterval(this.state.checkPayment)
        this.setState({step: 2})
      }
    })
  }



  render() {
    const {url, dismiss, proceed, browser_type} = this.props
    const {step} = this.state

    if(step == 1){
      return (
        <div className='wechat-poster-payment-modal-content'>
          <div className='wechat-pay-title'>{__('Please Use WeChat Scan Pay', locale)}</div>
          <QRCode value={url} />
          {browser_type == 'mobileBroswer' && <img src={require('./images/paymentProcess.jpg')} /> }
        </div>
      )
    } else if(step == 2){
      return(
        <div className='wechat-poster-success-modal-content text-center'>
          <img src={require('./images/Group@2x.png')} />
          <p>{__('Payment Successful', locale)}</p>
          <button className='btn btn-primary btn-block' onClick={() => {
            proceed({paySuccessful: true})
            dismiss()
          }}>{__('Complete', locale)}</button>
        </div>
      )
    }
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/weChatPosterPayment/ModalContent.js